import { lazy } from 'react';


export {default as KandySession} from './KandySession'
// 业务中心
export const ReportPage = lazy(() => import('../components/ReportPage'))
export const ReportDetail = lazy(() => import('../components/ReportDetail'))
// 除前海饿了么的工单详情wrapper
export const ReportCreate = lazy(() => import('./ReportDetail/ReportCreate'))
// 前海饿了么的工单详情wrapper
export const ReportCreateNew = lazy(() => import('./ReportDetail/ReportCreateNew'))
// 消息留言
export const LossMessage = lazy(() => import('./ReportTabs/LossMessage'))
// 饿了么风控
export const EleControlPane = lazy(() => import('./ReportTabs/EleControlPane'))

// 以下为各个租户的工单详情Form
// 8-太保饿了么; 10-太保达达
export const CpicReportDetailFoot = lazy(() => import('./ReportDetail/CpicReportDetailFoot'));
// 11-英大丹鸟
export const DanNiaoReportDetailFoot = lazy(() => import('./ReportDetail/DanNiaoReportDetailFoot'));
// 12-太保-南京大排档
export const NJdpdReportDetailFoot = lazy(() => import('./ReportDetail/NJdpdReportDetailFoot'));
// 13-人保-圆通
export const YuanTongReportDetailFoot = lazy(() => import('./ReportDetail/YuanTongReportDetailFoot'));
// 14-中华-哈啰
export const HLReportDetailFoot = lazy(() => import('./ReportDetail/HLReportDetailFoot'));
// 15-大家-追星保时捷
export const StarChaseReportDetailFoot = lazy(() => import('./ReportDetail/StarchaseReportDetailFoot'));
// 16-大地-哈啰
export const CCICHLReportDetailFoot = lazy(() => import('./ReportDetail/CCICHLReportDetailFoot'));
// 17-人保达达
export const PICCdadaReportDetailFoot = lazy(() => import('./ReportDetail/PICCdadaReportDetailFoot'));
// 18-大家-享赔
export const DAJIAReportDetailFoot = lazy(() => import('./ReportDetail/DAJIAReportDetailFoot'));
// 19-大地-盗抢险
export const RobberyCCICHLReportDetailFoot = lazy(() => import('./ReportDetail/RobberyCCICHLReportDetailFoot'));
// 20-前海雇主
export const QIANHAIReportDetailFoot = lazy(() => import('./ReportDetail/QIANHAIReportDetailFoot/index.jsx'));
// 23-新版饿了么
export const NewElmReportDetailFoot = lazy(() => import('./ReportDetail/NewElmReportDetailFoot/index'));
// 前海饿了么
export const QHELEReportDetailForm = lazy(() => import('./ReportDetail/Form/QHELEReportDetailForm'));
// 前海达达
export const QHDADAReportDetailForm = lazy(() =>import('./ReportDetail/Form/QHDADAReportDetailForm'));
// 前海分公司，前海深圳，前海湖北
export const QHBranchReportDetailForm = lazy(() =>import('./ReportDetail/Form/QHBranchReportDetailForm/index'));